<template>
  <b-modal
    v-if="showCoupon" v-model="visible"
    modal-class="couponSuggestion" body-class="couponSuggestion__body" content-class="couponSuggestion__content"
    noCloseOnBackdrop noCloseOnEsc hideHeader hideFooter noFade
    noEnforceFocus ref="couponSuggestion">
    <b-img-lazy :src="showCoupon.img" fluid />
    <b-button @click.prevent="$refs.couponSuggestion.hide" class="couponSuggestion__close">
      <svg-icon name="icon-close" :width="isMoblie ? 30: 35" :height="isMoblie ? 30: 35" />
    </b-button>
  </b-modal>
</template>

<script>
  export default {
    props: {
      channel: {
        type:     Object,
        required: true,
      },
    },
    head () {
      return {
        bodyAttrs: {
          style: this.visible ? 'overflow: auto;' : undefined,
        },
      }
    },
    data () {
      return {
        visible: false,
        coupons: [
          {
            // 全站訂起來
            start:    '2020-07-10T00:00:00+0800',
            end:      '2020-07-31T23:59:59+0800',
            type:     'all',
            img:      'images/u/uid/service/product/all.png',
            channels: [
              '0164a90d0a25000019c7000000000000',
              '0164a90f6515000019c7000000000000',
              '01650ee01b1700001bbc000000000000',
              '01650ee127a3000070d5000000000000',
              '01671588a8a900000e09000000000000',
              '0169563d6e5a00006bea000000000000',
              '0169953c12dd00005282000000000000',
              '0169953c95f200001d35000000000000',
              '0169953ded4200005282000000000000',
              '0169d70f11e6000050db000000000000',
              '016b9cfddaef00000868000000000000',
              '016b9cfe9c8200000888000000000000',
              '016b9cff0afa00000888000000000000',
              '016bbaf60c3b00000883000000000000',
              '016c2d2bf02600001c0a000000000000',
              '016c2d2d775900001bae000000000000',
              '016c4113c3d800001025000000000000',
              '016c4115440a00001025000000000000',
              '016c83c4091000005434000000000000',
              '016cf5419465000004b4000000000000',
              '016d5c2e755100000608000000000000',
              '016dc8712fd500000607000000000000',
              '016decae7501000059b4000000000000',
              '016e372507c5000005fe000000000000',
              '016efe04612f00000601000000000000',
              '016f21501e9b00000608000000000000',
              '016f22f591d700000601000000000000',
              '016f22f64bc100000601000000000000',
              '016f22f7200100000601000000000000',
              '016f22f7880200000608000000000000',
              '016f22f7d45b00000601000000000000',
              '016f6b0a62c300000608000000000000',
              '016f89c1d2e400000606000000000000',
              '016ff4a5055f00000609000000000000',
              '016ff614923b00000609000000000000',
              '017066c93bb7000038be000000000000',
              '017066cbb9ef00003781000000000000',
              '017066cc8e36000078ef000000000000',
              '01706718d34300003781000000000000',
              '0170671d1853000038be000000000000',
              '0170671f788100003781000000000000',
              '017099fae14f00000606000000000000',
              '0170cdcf624300000604000000000000',
              '0170cdd9e82f00000605000000000000',
              '0170ce00a5d900000607000000000000',
              '0170ce03001500000605000000000000',
              '0170ce5268c400000604000000000000',
              '017105bc7b7d00000604000000000000',
              '01711039c8af00000605000000000000',
              '0171103a3dff00000603000000000000',
              '0171103d8fa600000605000000000000',
              '017133a5f15600000606000000000000',
              '017133cf08fd00000601000000000000',
              '017133d1192c00000605000000000000',
              '0171b5ea373b00000623000000000000',
              '0171b9b1adbd0000061f000000000000',
              '01720d8724d900000621000000000000',
              '01720d878d5900000624000000000000',
              '0172313780c80000061a000000000000',
              '017250b7377f00000620000000000000',
              '017291c57ddf00000622000000000000',
              '0172975db66800000622000000000000',
              '0172975e472c00000622000000000000',
              '01729d9e152000000622000000000000',
              '01729d9e811e00000622000000000000',
              '017303508a9500002120000000000000',
              '017303514c7e00002120000000000000',
              '01730351c3c80000691b000000000000',
              '016638b336f10000109c000000000000',
            ],
          },
          { // 期貨達人
            start:    '2020-07-20T00:00:00+0800',
            end:      '2020-07-27T23:59:59+0800',
            type:     'futures',
            img:      'images/u/uid/service/product/futures.png',
            channels: [
              '01659d50a29e00005253000000000000',
              '0164a904e783000014d0000000000000',
              '01650ee01b1700001bbc000000000000',
              '01650ee127a3000070d5000000000000',
              '0166ae4e646100007620000000000000',
              '0166ae5185be00002c6e000000000000',
              '017099fae14f00000606000000000000',
              '016e6e154d7900000604000000000000',
              '016e6e15f50700000604000000000000',
              '016e6e1691cc00000604000000000000',
              '016d5c2e755100000608000000000000',
              '0171b9b1adbd0000061f000000000000',
              '016bbaf60c3b00000883000000000000',
            ],
          },
          { // 全球財經
            start:    '2020-07-24T00:00:00+0800',
            end:      '2020-07-31T23:59:59+0800',
            type:     'economy',
            img:      'images/u/uid/service/product/economy.png',
            channels: [
              '017303508a9500002120000000000000',
              '017303514c7e00002120000000000000',
              '01730351c3c80000691b000000000000',
              '016e372507c5000005fe000000000000',
              '0164a90f6515000019c7000000000000',
              '0167158829070000150c000000000000',
              '01671588a8a900000e09000000000000',
              '01671589650300000e09000000000000',
              '017133a5f15600000606000000000000',
            ],
          },
        ],
      }
    },
    computed: {
      availableCoupons () {
        return this.coupons.filter(
          coupon => (
            (!coupon.start || this.$moment().valueOf() >= this.$moment(coupon.start).valueOf())
            && (!coupon.end || this.$moment().valueOf() <= this.$moment(coupon.end).valueOf())
          ),
        )
      },
      allCoupon () {
        return this.availableCoupons.find(availableCoupon => availableCoupon.type === 'all')
      },
      futuresCoupon () {
        return this.availableCoupons.find(availableCoupon => availableCoupon.type === 'futures')
      },
      economyCoupon () {
        return this.availableCoupons.find(availableCoupon => availableCoupon.type === 'economy')
      },
      showCoupon () {
        if (_.get(this.futuresCoupon, 'channels', []).includes(this.channel.identity)) {
          return this.futuresCoupon
        }

        if (_.get(this.economyCoupon, 'channels', []).includes(this.channel.identity)) {
          return this.economyCoupon
        }

        if (_.get(this.allCoupon, 'channels', []).includes(this.channel.identity)) {
          return this.allCoupon
        }

        return null
      },
      isMoblie () {
        return this.windowWidth < 768
      },
    },
    async mounted () {
      if (this.showCoupon) {
        // b-modal 會計算捲動條的寬度並實際加上去到 body 上（如果滾動條存在，像是 Windows 都會存在）
        // 因 CouponSuggestion 將遮罩拿掉後會看到 body 上有明顯的間距，因此要將間距拿掉
        // 參考來源: https://github.com/bootstrap-vue/bootstrap-vue/blob/dev/src/components/modal/helpers/modal-manager.js#L147
        // eslint-disable-next-line import/no-extraneous-dependencies
        const { modalManager } = await import('bootstrap-vue/src/components/modal/helpers/modal-manager')
        this.$refs.couponSuggestion.$once('shown', () => {
          // 先取得捲動條的寬度如果不存在就會是 0
          modalManager.getScrollbarWidth()
          // 如果 scrollbarWidth 有值，代表滾動條是存在的，要將 b-modal 設定的間距移除
          if (modalManager.scrollbarWidth) modalManager.resetScrollbar()
        })
        this.$refs.couponSuggestion.show()
      }
    },
  }
</script>

<style lang="scss">
  .couponSuggestion {
    height: auto;
    top: auto;
    bottom: 10px;

    @include media-breakpoint-up(md) {
      width: auto;
      left: 20px;
    }

    &__body {
      padding: 0;
      position: relative;
    }

    &__close {
      position: absolute;
      z-index: 1;
      padding: 0;
      margin: 0;
      border: none;
      right: 6px;
      top: 7px;

      @include media-breakpoint-up(md) {
        right: 8px;
        top: 6px;
      }

      &:hover {
        opacity: 0.8;
      }
    }

    &__content {
      background-color: transparent;
      border: none;
      border-radius: 0;
      box-shadow: none;
    }

    & ~ .modal-backdrop {
      display: none;
    }

    .modal-dialog {
      margin: 0 auto;
      max-width: 475px;

      @include media-breakpoint-up(md) {
        margin: 0;
        max-width: 500px;
      }
    }
  }
</style>
